export const siteData = {
    name: 'Nexon Digital Studio',
    legalName: 'Dmytro Kiriachek handelnd unter Nexon Digital Studio',

    url: 'https://nexon-studio.de',
    language: 'de-DE',
    locale: 'de_DE',

    header: {
        menuLabel: 'Menü',
        backLabel: 'Zurück',
        buttonLabel: 'Anfrage senden',
    },

    contact: {
        phone: '+49 15510629166',
        phoneHref: '+4915510629166',
        email: 'dmytro@nexon-studio.de',
        whatsapp: '+49 15510629166',
        formUrl: 'https://nexon-studio.de/#contacts',
    },

    address: {
        street: 'Collegienstr. 59A',
        postalCode: '06886',
        city: 'Lutherstadt Wittenberg',
        country: 'Deutschland',
        countryCode: 'DE',
    },

    links: {
        linkedin: 'https://www.linkedin.com/in/dmitriy-kiryachek-bb7272239',
        whatsapp: 'https://wa.me/4915510629166',
        instagram: 'https://www.instagram.com/dmitriy.uier?utm_source=nexon-studio-site',
        telegram: 'https://t.me/dmitriy_uier',
    },

    footer: {
        slug: 'Shopify-Shops, die verkaufen',
        legalLinks: [
            {
                label: 'Impressum',
                path: '/impressum/',
            },
            {
                label: 'Datenschutz',
                path: '/datenschutz/',
            },
        ],
        cookieSettings: 'Cookie-Einstellungen',
    },
};
